<template>
  <div class="menu-wrapper">
    <template v-for="item in menuData">
      <!--只有一级菜单 -->
      <el-menu-item v-if="onlyOne(item)" :index="filterPath(item)" class="first-level-menu-item" @click="openPage(item)" :key="item.label">
        <div class="menu-item-box flex acenter" :style="getMenuItemBoxPL(item)">
          <img :src="require(`@/assets/img/menu/${item.icon }.svg`)" class="icon"/>
          <span slot="title" class="menu-item-title" v-if="!isCollapse">{{ $t(item.label) }}</span>
        </div>
      </el-menu-item>
      <!--多级菜单-->
      <el-submenu v-if="item.children && item.children.length > 0" :index="filterPath(item)" :key="item.label">
        <!--父级菜单-->
        <template slot="title">
          <div class="submenu-box flex acenter">
            <img :src="require(`@/assets/img/menu/${item.icon }.svg`)" class="icon"/>
            <span slot="title" v-if="!isCollapse">{{ $t(item.label) }}</span>
          </div>
        </template>
        <!--子级菜单-->
        <template v-for="(child,cindex) in item.children">
          <sidebar-item v-if="child.children && child.children.length > 0" :menuData="[child]" :key="cindex" :isCollapse="isCollapse"></sidebar-item>
          <el-menu-item v-else :index="filterPath(child)" @click="openPage(child)" :key="cindex">
            <div class="menu-item-box flex acenter" :style="getMenuItemBoxPL(child)">
              <span slot="title">{{ $t(child.label) }}</span>
            </div>
          </el-menu-item>
        </template>
      </el-submenu>
    </template>
  </div>
</template>
<script>
  import {ygjMenuParamTo} from "@/api/user/login";
  import {mapGetters, mapMutations} from "vuex";

  export default {
    name: 'SidebarItem',
    data() {
      return {
        menus: null
      };
    },
    inject: ['reload'],
    props: {
      menuData: {
        type: Array,
        default() {
          return []
        }
      },
      isCollapse: {
        type: Boolean,
      },
      showIcon: {
        type: Boolean,
        default: false
      }
    },
    mounted() {
    },
    computed: {
      ...mapGetters(['isCollapse', 'ygj', 'userInfo']),
      onlyOne() {
        const that = this;
        return function (item) {
          if (!item.children || item.children.length === 0) {
            return true;
          }
        };
      },
    },
    methods: {
      ...mapMutations({
        SET_MENU_LOADING: 'SET_MENU_LOADING'
      }),
      filterPath(menu) {
        return menu.path == null ? menu.id : menu.path;
      },
      //判断两个对象值相不相等
      isEqual(a, b) {
        const classNameA = toString.call(a)
        const classNameB = toString.call(b)
        // 如果数据类型不相等，则返回false
        if (classNameA !== classNameB) {
          return false
        } else {
          // 如果数据类型相等，再根据不同数据类型分别判断
          if (classNameA === '[object Object]') {
            for (let key in a) {
              if (!this.isEqual(a[key], b[key])) return false
            }
            for (let key in b) {
              if (!this.isEqual(a[key], b[key])) return false
            }
            return true
          } else if (classNameA === '[object Array]') {
            if (a.length !== b.length) {
              return false
            } else {
              for (let i = 0, len = a.length; i < len; i++) {
                if (!this.isEqual(a[i], b[i])) return false
              }
              return true
            }
          } else if (classNameA === '[object Function]') {
            return a.toString() === b.toString()
          } else {
            return Object.is(a, b)
          }
        }
      },
      openPage(item) {
        // 清除记录的tab  name
        if(sessionStorage.getItem("tabIndex")){
          sessionStorage.removeItem("tabIndex")
        }
        let path = item.path;
        let params = "";
        // 处理路由URL带参数的菜单
        if(typeof item.params === 'function') {
          params = item.params(this.$store);
          if(item.path && item.path.indexOf('/:') !== -1){
            const pathItemArr = item.path.split('/');
            pathItemArr.forEach((pathItem) => {
              if(pathItem.indexOf(':') === 0) {
                const paramName = pathItem.substring(1);
                path = path.replace(pathItem,params[paramName])
              }
            })
          }
        }
        if (item.path === this.$route.path) {
          this.reload();
          if(item.query !=undefined ){
            this.$router.push({
              path: path,
              query: item.query,
            });
          }
        } else {
          if(item.query !=undefined ){
            this.$router.push({
              path: path,
              query: item.query,
            });
          }else{
            this.$router.push({
              path: path
            });
          }
        }
      },
      loadingUrl(isLoading) {
        this.SET_MENU_LOADING(isLoading);
      },
      setFullPath(targetUrl, path, fullPath) {
        this.$router.push({
          path: path
        });
      },
      getMenuItemBoxPL(val){
        let level = val.level || 1;
        return {
          'padding-left': level * 21 + 'px'
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  .el-menu-item {
    background: #FFFFFF !important;
    padding: 0 20px !important;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    &:not(.first-level-menu-item) {
      .menu-item-box:before {
        content: '';
        display: inline-block;
        width: 5px;
        height: 5px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        background-color: #999;
        margin-right: 10px;
        margin-left: -12px;
      }
    }

    .menu-item-box {
      span {
        color: #666666;
      }
      &:hover {
        background: #f9eae9 !important;
      }
    }

    &.is-active {
      .menu-item-box {
        background: #f9eae9 !important;
        &:before {
          background-color: #C73122 !important;
        }

        span {
          color: #C73122 !important;
          font-weight: bold;
        }
      }
    }
  }

  .el-submenu {
    background-color: #FFFFFF !important;

    .submenu-box {
      height: 56px;
    }
    ::v-deep .el-submenu__title {
      span {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1C1C1C;
        line-height: 22px;
      }
      &:hover {
        background: #f9eae9 !important;
      }
    }
    ::v-deep .el-submenu__icon-arrow {
      font-size: 16px !important;

      &:before {
        content: '\E790' !important;
      }
    }
    &.is-opened ::v-deep .el-submenu__title .el-submenu__icon-arrow {
      color: #C73122 !important;
    }
  }

  .first-level-menu-item {
    padding: 0 !important;

    .menu-item-box {
      height: 56px;
      .menu-item-title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
      }
    }
  }

  .menu-item-box,
  .submenu-box{
    .icon {
      width: 18px;
      height: 18px;
      margin-right: 5px;
    }
  }
</style>
